import styles from './styles.module.css'

const Tag = ({ closeButton, onClose, className = '', children }) => {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <span className={styles.label}>{children}</span>

      {closeButton && (
        <button className={styles.button} onClick={onClose}>
          <svg width='12px' height='12px' viewBox='0 0 12 12'>
            <use xlinkHref='/icons.svg#icon-cross' />
          </svg>
        </button>
      )}
    </div>
  )
}

export default Tag
